export const calculateRoomFromPath = (path: string): string => {

  if(path.indexOf("/formviewer/") > -1){
    return path.split("/formviewer/")[1]
  }
  else {
    return "general"
  }
}